import React from 'react';
import DeviationDumbView from '../DeviationViews/Dumbo';
import DeviationLink from '../Duperbrowse/DeviationLink';
var PollOptionThumb = function (_a) {
    var deviation = _a.deviation, size = _a.size;
    return deviation ? (React.createElement(DeviationLink, { deviation: deviation, target: "_blank" },
        React.createElement(DeviationDumbView, { deviation: deviation, width: size, height: size }))) : (
    // Deviation is inactive/deleted
    // Render an Unknown thumb (a "null" deviation) instead
    React.createElement(DeviationDumbView, { deviation: {}, width: size, height: size }));
};
PollOptionThumb.displayName = 'PollOptionThumb';
export default PollOptionThumb;
//# sourceMappingURL=PollOptionThumb.js.map